/**
 * TanStack Query hooks for Metrics service
 */

import { useQuery } from '@tanstack/react-query';
import {
  getWeeklyMetrics,
  getRitualStats,
  type WeeklyMetrics,
  type RitualStats,
} from '@/lib/services/metrics';

// Query keys
export const metricsKeys = {
  all: ['metrics'] as const,
  weekly: (startDate?: string, endDate?: string) =>
    [...metricsKeys.all, 'weekly', startDate, endDate] as const,
  ritualStats: () => [...metricsKeys.all, 'ritual-stats'] as const,
};

/**
 * Get weekly metrics
 */
export function useWeeklyMetrics(startDate?: Date, endDate?: Date) {
  return useQuery<WeeklyMetrics>({
    queryKey: metricsKeys.weekly(startDate?.toISOString(), endDate?.toISOString()),
    queryFn: () => getWeeklyMetrics(startDate, endDate),
    staleTime: 1000 * 60 * 5, // 5 minutes
    retry: false, // Don't retry on error - services return defaults
  });
}

/**
 * Get ritual statistics
 */
export function useRitualStats() {
  return useQuery<RitualStats>({
    queryKey: metricsKeys.ritualStats(),
    queryFn: getRitualStats,
    staleTime: 1000 * 60 * 5, // 5 minutes
    retry: false, // Don't retry on error - services return defaults
  });
}
